// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"661":"c57bdc08","712":"f2aacbe9","839":"f366f527","878":"f366f527","944":"ede57257"}[chunkId] + ".chunk.css";
};